<template>
  <li class="link-list-item">
    <div class="link-list-item__main" :class="secondaryLink ? 'link-list-item__main--with-secondary' : ''">
      <Link :to="primaryLink" class="primary-link">
        <slot name="main-content" />
      </Link>
      <Link v-if="secondaryLink" :to="secondaryLink" class="secondary-link">
        <slot name="secondary-content" />
      </Link>
      <div v-else-if="alwaysRenderSecondaryLink" />
    </div>
    <div class="link-list-item__actions">
      <slot name="action-content" />
    </div>
  </li>
</template>

<script>
export default {
  name: 'LinkListItem',
  props: {
    primaryLink: { type: [String, Object], required: true },
    secondaryLink: { type: [String, Object], required: false },
    // in some lists the secondaryLink is null only for some items, to fix alignment this can be set
    alwaysRenderSecondaryLink: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.link-list-item {
  width: 100%;
  position: relative;
  display: flex;
  background-color: #fff;
  margin-bottom: 0.75rem;
  border-radius: var(--border-radius-m);
  border: 1px solid var(--border-color);

  &.disabled {
    opacity: 0.5;
  }

  &:hover {
    box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.1);
  }
}
.link-list-item__main {
  padding: 1.25rem;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  color: var(--primary-font-color);
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &.link-list-item__main--with-secondary {
    grid-template-columns: 3fr 1fr;
  }

  &:hover {
    color: var(--primary-font-color);
  }

  & .primary-link {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    color: var(--primary-font-color);

    &:hover {
      color: var(--primary-font-color);
    }

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }

  & .secondary-link {
    position: relative;
    text-decoration: underline;
  }
}

.link-list-item__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  padding: 0.75rem;

  & .link-list-item__action {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 0;
    background-color: transparent;
    background-image: none;
    border: none;
    color: var(--primary-font-color);
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    width: 24px;
    height: 24px;
    transition: color 250ms;
    &:hover {
      color: #000;
    }
    &[disabled] {
      cursor: not-allowed;
      background-color: transparent;
      color: #999;
      &:hover {
        background-color: transparent;
        color: #999;
      }
    }
  }
}
</style>
